import { useQuery } from '@tanstack/react-query';
import { logoutApi } from '../api/logout.api';
import type { BlacklistStatusResponse } from '../types/logout.types';

/**
 * Query: GET /api/eraf/auth/logout/blacklist-status?jti=...
 * Only fetches when enabled=true (user has submitted a jti to look up).
 */
export function useBlacklistStatus(jti: string, enabled: boolean) {
  return useQuery<BlacklistStatusResponse, { code: string; message: string }>({
    queryKey: ['logout', 'blacklist', jti],
    queryFn: () => logoutApi.getBlacklistStatus(jti),
    enabled: enabled && jti.trim().length > 0,
    retry: false,
    staleTime: 0,
  });
}
